<template>
  <p v-html="tr('common.REQUIRED_FIELDS')"></p>
</template>

<script>
  import { translator } from '~/zf/frontend/common/mixins';

  export default {
    name: 'RequiredFields',
    compatConfig: {
      MODE: 3,
    },
    mixins: [translator],
  };
</script>
